<div class="item">
    <div class="custom-control custom-checkbox" *ngFor="let c of categories">
        <input [checked]="value.indexOf(c.id)>-1" (change)="change($event,c.id)" type="checkbox" class="custom-control-input" [id]="'c-'+c.id" name="example1">
        <label class="custom-control-label" [for]="'c-'+c.id">{{c.name}}</label>
    </div>
</div>
